<!-- 带有粒子特效的背景 -->
<template>
  <div v-if="model" class="effect-wraper">
    <div id="effect-container"></div>
    <!-- 上面是底板，下面是真实展示的东西 -->
    <div class="effect-show" v-show="is_show">
      <slot>你好</slot>
    </div>
  </div>
</template>
<script setup>
import { nextTick, onMounted } from 'vue';
import { Player, TextComponent } from '@galacean/effects';
let player = null;
const props = defineProps({
  'close-on-click-overlay': {
    type: Boolean,
    default: true,
  },
});

const model = defineModel();
function handleClose() {
  if (props['closeOnClickOverlay']) {
    model.value = false;
  } else {
    return;
  }
}

async function handle_load() {
  player = new Player({
    container: document.getElementById('effect-container'),
    interactive: true,
  });
  const comp = await player.loadScene(
    // 'https://g20.gsf.netease.com/2025071507/hongbao/hongbao.json',
    'https://g20.gsf.netease.com/2025091901/2025091901/dialog.json',
    {
      autoplay: true,
    }
  );
  player.on('click', (e) => {
    if (e.name == 'interact_35') {
      player.dispose();
    } else {
      player.dispose();
    }
  });
}
watch(model, (v) => {
  if (v == true) {
    document.body.classList.add('tx-dialog-hidden');
    nextTick(() => {
      handle_load();
    });
  } else {
    document.body.classList.remove('tx-dialog-hidden');
  }
});
onMounted(() => {
  if (model.value == true) {
    document.body.classList.add('tx-dialog-hidden');
  }
});
</script>
<style>
#effect-container {
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 100;
  top: 0;
}

.effect-wraper {
  height: 100vh;
  width: 100vw;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
}

.effect-show {
  z-index: 101;
}
</style>
